var sin;
if (!sin) {
    sin = {};
}

$.extend(sin,
    /**
     * @lends sin
     */
    {
        /**
         * @namespace
         * @description slider
         */
        slider: {
            _obj: [],
            _selector: '.swiper--twoSlides',
            _config: {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 20,
                preloadImages: false,
                lazy: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    768: {
                      slidesPerView: 1
                    }
                }
            },
            
            /**
             * @type {function}
             * @description initialize News Slider
             */
            init: function () {
                $(sin.slider._selector).each(function(i){
                    var t = $(this);
                    t.attr('id', 'swiper' + i);

                    sin.slider._obj[i] = new Swiper(sin.slider._selector, sin.slider._config);
                });

                
            }
        }
    }
);

$(sin.slider.init);
